import { render, staticRenderFns } from "./PositionChange.vue?vue&type=template&id=09fff935&scoped=true&"
import script from "./PositionChange.vue?vue&type=script&lang=js&"
export * from "./PositionChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-internal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fff935",
  null
  
)

export default component.exports